import React from 'react'

import HARDCODE from '../../business-const/HardCode/HardCode'

//import ReactWhatsapp from 'react-whatsapp'

import {
    formataCelular,
} from '../../business-components/Formata/Formata'

import {
    IconButtonWhatsApp,
} from '../../business-components/IconButton/IconButton'

export const WhatsApp = ({className, codigoPais, numero, exibirNumero,/* numeroFormatado,*/ svgIconButtonFontSize, mensagem}) => {

    //if (!numero) {

    //    numero = HARDCODE.whatsappUrl
    //}

    if (!codigoPais) {

        codigoPais = HARDCODE.codigoPais
    }

    return (
        <a
            className={className}
            target="_blank"
            rel="noopener noreferrer" 
            href={
                mensagem
                    ?
                        "https://api.whatsapp.com/send?phone=" + codigoPais + numero + "&text=" + mensagem
                    :
                        "https://wa.me/" + codigoPais + numero
            }
        >
            <IconButtonWhatsApp
                tooltipTitle={formataCelular(numero)}
                svgIconButtonFontSize={svgIconButtonFontSize}

            />


            {/*numero === HARDCODE.whatsappUrl ? HARDCODE.whatsappUrlFormatado : numeroFormatado*/}
            {exibirNumero ? formataCelular(numero) : ''}
        </a>
    )
}
/*
  <>
            <ReactWhatsapp
                number={HARDCODE.whatsappUrl}
                element={IconButtonWhatsapp}
            />

            {HARDCODE.whatsappText}
        </>
*/